// Global loading state tracker for Supabase requests
let inFlightRequests = 0;
let loadingCallbacks = [];

export const loadingState = {
  subscribe(callback) {
    loadingCallbacks.push(callback);
    return () => {
      loadingCallbacks = loadingCallbacks.filter(cb => cb !== callback);
    };
  },
  getCount() {
    return inFlightRequests;
  }
};

// Patch fetch to track Supabase requests
export function initLoadingInterceptor() {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  if (!supabaseUrl) return;

  const originalFetch = window.fetch;

  window.fetch = async function(...args) {
    const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;
    
    // Only track Supabase API calls (not storage/CDN)
    const isSupabaseAPI = url && url.includes(supabaseUrl) && url.includes('/rest/');
    
    if (isSupabaseAPI) {
      inFlightRequests++;
      notifySubscribers();
    }

    try {
      const response = await originalFetch.apply(this, args);
      return response;
    } finally {
      if (isSupabaseAPI) {
        inFlightRequests--;
        notifySubscribers();
      }
    }
  };
}

function notifySubscribers() {
  loadingCallbacks.forEach(callback => callback(inFlightRequests));
}
